import React from 'react';

class YourDetails extends React.Component {
    render() {
        return (
            <div>
                <div className="head">
                    <h2>Your Details</h2>
                </div>
                <div className="form">
                    <input type="text" name="name" value={this.props.name} placeholder="Your Name" onChange={this.props.handleUpdate} maxLength={255} />
                    <input type="email" name="email" value={this.props.email} placeholder="Your Email Address" onChange={this.props.handleUpdate} maxLength={255} />
                </div>
                <div className="head">
                    <h2>Your Place of Work</h2>
                </div>
                <div className="form">
                    <input type="text" name="company" value={this.props.company} placeholder="Company Name" onChange={this.props.handleUpdate} maxLength={255} />
                    <input type="text" name="position" value={this.props.position} placeholder="Your Position / Job Title" onChange={this.props.handleUpdate} maxLength={255} />
                </div>
            </div>
        )
    }
}

export default YourDetails;